//Built-in libraries

import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//Services
import { accountingFormatNumber, formatDate3 } from '@/utils';
//Custom components
import ReviewCard from './ReviewCard';

//STP Libraries

//Assets and Miscellaneous
import { Accordion, AccordionItem } from '@/components/UI/Accordion';

//Component Begin

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();
  const { step1, step2, step5 } = data;

  return (
    <div className={'space-y-5 px-6 py-4 lg:col-span-9'}>
      <ReviewCard title='Application Details' handleEdit={() => setCurrentStep(1)}>
        <dl>
          <div className='bg-gray-200 px-5 py-4 font-semibold'>
            <h5>Project Information</h5>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Name of Bond Bill</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.bondBill}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Legislative District</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.legislativeDistrict}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Chapter Number</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.chapterNumber}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Year Authorized</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {formatDate3(step1.section1.authorizedYear.toDateString())}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>DGS Item Number</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.dgsItemNumber}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Project Title</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.projectTitle}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Project Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.streetAddress}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.state}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Zip/Postal Code</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section1.zipCode}</dd>
          </div>
          <div className='bg-gray-200 px-5 py-4 font-semibold'>
            <h5>Grantee Information</h5>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Legal Name of Grantee Organization</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section2.granteeOrganization}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section2.streetAddress}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section2.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section2.state}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Grant Amount</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: step1.section2.grantAmount ? step1.section2.grantAmount : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Match Amount</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: step1.section2.matchAmount ? step1.section2.matchAmount : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-gray-200 px-5 py-4 font-semibold'>
            <h5>Grantee Interest in real property to be improved with Grant</h5>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Grantee organization is the sole owner</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.isSoloOwner ? 'Yes' : 'No'}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Grantee organization is a co-owner</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.isCoOwner ? 'Yes' : 'No'}</dd>
          </div>
          {step1.section3.isCoOwner && (
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Co-owner Name</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.coOwnerName}</dd>
            </div>
          )}
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Grantee don’t own the property, but has a long-term lease.</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.hasLongTermLease ? 'Yes' : 'No'}</dd>
          </div>
          {step1.section3.hasLongTermLease && (
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Lease Term</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.leaseTerm}</dd>
            </div>
          )}
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Grantee does not own or lease the project property.</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.doesNotOwn ? 'Yes' : 'No'}</dd>
          </div>
          {step1.section3.doesNotOwn && (
            <>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Owner’s Name</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.ownerName}</dd>
              </div>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Owner’s Email Address</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.ownerEmail}</dd>
              </div>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Owner’s Phone Number</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section3.ownerPhoneNumber}</dd>
              </div>
            </>
          )}
          <div className='bg-gray-200 px-5 py-4 font-semibold'>
            <h5>Estimated Project Schedule</h5>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Design</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>Start Date: {formatDate3(step1.section4?.design.startDate.toDateString())}</span>
              <span>Finish Date: {formatDate3(step1.section4.design.finishDate.toDateString())}</span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Construction</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>Start Date: {formatDate3(step1.section4.construction.startDate.toDateString())}</span>
              <span>Finish Date: {formatDate3(step1.section4.construction.finishDate.toDateString())}</span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Project Detail & Scope</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.section4.description}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Require a preservation easement to the Maryland Historical trust ?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{step1.section4.requirePreservationEasement}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              You are encouraged to solicit MBE enterprises. Will this project utilize MBE enterprises to provide construction,goods and/or
              Services ?
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{step1.section4.utilizeMBEEnterprise}</dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Total Estimated Project Budget ' handleEdit={() => setCurrentStep(2)}>
        <div>
          {step2.estimatedProjectBudget.length > 0 && (
            <Accordion multi>
              <div className='px-6 py-4 space-y-4'>
                {step2.estimatedProjectBudget.map((project: any) => (
                  <div key={project.id} id={project.id} className='bg-white'>
                    <AccordionItem id={project.id} title={<p className='font-bold'>{project.item}</p>}>
                      <dl className='grid grid-cols-12'>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Item</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{project.item}</dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>State Grant</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {accountingFormatNumber({
                              num: project.stateGrant ? project.stateGrant : 0,
                              format: 'en-US',
                              currency: 'USD',
                            })}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Other Funds</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {accountingFormatNumber({
                              num: project.otherFunds ? project.otherFunds : 0,
                              format: 'en-US',
                              currency: 'USD',
                            })}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Total Costs</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {accountingFormatNumber({
                              num: project.totalFunds ? project.totalFunds : 0,
                              format: 'en-US',
                              currency: 'USD',
                            })}
                          </dd>
                        </div>
                      </dl>
                    </AccordionItem>
                  </div>
                ))}
              </div>
            </Accordion>
          )}
          {step2.estimatedProjectBudget.length === 0 && <div className='px-6 py-4'>None</div>}
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Construction at least $250,000 and State funds used to pay for 25% or more
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.q1 === 'yes' ? 'Yes' : 'No'}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Received $1,000,000 or more and construction contract $500,000 or more ?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step1.q2 === 'yes' ? 'Yes' : 'No'}</dd>
          </div>
        </div>
      </ReviewCard>
      <ReviewCard title='Disclosure' handleEdit={() => setCurrentStep(5)}>
        <div className='py-5'>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Name of Grantee Organization</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step5.granteeName}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Authorized Representative</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{step5.authorizedRepresentative}</dd>
          </div>
        </div>
      </ReviewCard>
    </div>
  );
}
